﻿import { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

import Fetching from "@/components/Fetching/Fetching";

import { useWebContent } from "@/hooks/maintainers/web_contents";
import { validRoles, toast } from "@/services/Utils";

import { base_element } from "../web_content.constants";
import classes from "../../maintainers.module.scss";

import WebContentMain from "./WebContentMain";
import WebContentPricing from "./WebContentPricing";
import WebContentMetrics from "./WebContentMetrics";
import WebContentIntegrations from "./WebContentIntegrations";
import WebContentServices from "./WebContentServices";
import WebContentBenefits from "./WebContentBenefits";
import WebContentAboutUs from "./WebContentAboutUs";
import WebContentCustomers from "./WebContentCustomers";
import WebContentTestimonials from "./WebContentTestimonials";
import WebContentQualityService from "./WebContentQualityService";
import WebContentTeam from "./WebContentTeam";
import WebContentValues from "./WebContentValues";
import WebContentApplications from "./WebContentApplications";

const WebFormContent = ({ confirmSave, isLoadingSave }) => {
	const { addToast } = useToasts();
	const { option, selected } = useParams();
	const location = useLocation();
	const navigate = useNavigate();

	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isAdmin = validRoles(userRoles, ["administrador"]);

	const { data: response, isLoading } = useWebContent(selected);

	const [data, setData] = useState({ ...base_element });

	const components = {
		Main: <WebContentMain data={data} setData={setData} />,
		Pricing: <WebContentPricing data={data} setData={setData} />,
		Metrics: <WebContentMetrics data={data} setData={setData} />,
		Integrations: <WebContentIntegrations data={data} setData={setData} />,
		Services: <WebContentServices data={data} setData={setData} />,
		Benefits: <WebContentBenefits data={data} setData={setData} />,
		AboutUs: <WebContentAboutUs data={data} setData={setData} />,
		Customers: <WebContentCustomers data={data} setData={setData} />,
		Testimonials: <WebContentTestimonials data={data} setData={setData} />,
		QualityService: <WebContentQualityService data={data} setData={setData} />,
		Team: <WebContentTeam data={data} setData={setData} />,
		Values: <WebContentValues data={data} setData={setData} />,
		Applications: <WebContentApplications data={data} setData={setData} />,
	};

	useEffect(() => {
		if (response) {
			setData(response.detail);
		}
	}, [response]);

	const handleClose = () => {
		if (location.state) {
			navigate(location.state);
			return;
		}

		navigate("/mantenedores/contenidos_web");
	};

	const handleSave = () => {
		if (validSave()) {
			confirmSave(data);
		}
	};

	const validSave = () => {
		if (!data.pretitle) {
			toast(addToast, "Debe ingresar el antetítulo para guardar.", "error");
			return false;
		}
		if (!data.title) {
			toast(addToast, "Debe ingresar el título para guardar.", "error");
			return false;
		}

		return true;
	};

	return (
		<Modal
			show={option ? true : false}
			onHide={handleClose}
			backdrop="static"
			keyboard={false}
			className={classes.main_form}
			size={data && data.modal_size}
		>
			<Modal.Header closeButton>
				<h4 className={classes.modal_title}>{data && data.name ? data.name : ""}</h4>
			</Modal.Header>
			<Modal.Body>{isLoading || isLoadingSave ? <Fetching topMargin={"1em"} /> : components[data.name]}</Modal.Body>
			<Modal.Footer>
				{isAdmin && (
					<Button variant="success" onClick={handleSave} disabled={isLoading || isLoadingSave}>
						GUARDAR
					</Button>
				)}
			</Modal.Footer>
		</Modal>
	);
};

export default WebFormContent;
